type DeviceIconProps = {
  color?: string;
  size?: number | string;
};

export const DeviceIcon = ({ color = 'currentColor', size = 16 }: DeviceIconProps): JSX.Element => (
  <svg style={{ color }} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 14L2.66667 10.7V5.3L8 2L13.3333 5.3V10.7L8 14ZM8 14V8.02299M2.66667 5.33333L8 8.02299M8 8.02299L13.3333 5.33333" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);
